// Tela 1 — Capa. Extraído literalmente de entrevista-sergio-gargantini.html
// (bloco #s1), refatorado de ID para classe `.tpl-capa` para permitir repetir
// o template na mesma matéria. Ver DOCS/01-capa.md.
import { formatWithBoldLines, escapeHtml } from '../shared/text'
import { LOGO_PRETO_DATA_URI } from '../shared/logo'
import type { TemplateDefinition } from '../types'

export const CSS = `
  .tpl-capa{
    padding:0 65px;
    position:relative;
  }
  .tpl-capa .credits{
    position:absolute;
    top:82px;
    left:74px;
    right:65px;
    font-family:'Big Shoulders',sans-serif;
    font-size:16px;
    font-weight:300;
    line-height:1;
    letter-spacing:.09em;
    white-space:nowrap;
    color:#969696;
  }
  .tpl-capa .credits strong{
    color:var(--ink);
    font-weight:700;
  }
  .tpl-capa .hero{
    position:absolute;
    top:178px;
    left:65px;
    right:65px;
  }
  .tpl-capa .watermark{
    position:absolute;
    top:0;
    left:0;
    font-family:'Anton',sans-serif;
    font-size:min(var(--template-vw-17-5, 17.5vw), 112px);
    line-height:1;
    color:var(--ghost);
    letter-spacing:-.01em;
    white-space:nowrap;
    z-index:0;
  }
  .tpl-capa .headline{
    position:absolute;
    top:50px;
    left:0;
    z-index:1;
    font-family:'Anton',sans-serif;
    font-size:min(var(--template-vw-17-2, 17.2vw), 110px);
    line-height:.88;
    letter-spacing:-.01em;
    color:var(--ink);
    text-transform:uppercase;
  }
  .tpl-capa .headline-text{
    display:block;
    transform:scaleY(1.5);
    transform-origin:top left;
  }
  .tpl-capa .dek{
    position:absolute;
    top:560px;
    left:65px;
    max-width:78%;
    font-family:'Big Shoulders',sans-serif;
    font-weight:400;
    font-size:clamp(14px,var(--template-vw-3-05, 3.05vw),19px);
    line-height:1.5;
    letter-spacing:.02em;
  }
  .tpl-capa .dek b{font-weight:700;}
  .tpl-capa .logo{position:absolute; left:65px; bottom:54px; height:24px;}
`

function render(content: Record<string, unknown>): string {
  const writer = escapeHtml(String(content.writer ?? 'André Pontes'))
  const photographer = escapeHtml(String(content.photographer ?? 'Airiela Leiria'))
  const watermark = escapeHtml(String(content.watermark ?? 'ENTREVISTA'))
  const line1 = escapeHtml(String(content.headlineLine1 ?? ''))
  const line2 = escapeHtml(String(content.headlineLine2 ?? ''))
  const dek = formatWithBoldLines(String(content.dek ?? ''))

  return `<section class="slide tpl-capa">
    <p class="credits reveal r1">por <strong>${writer}</strong> fotografia de <strong>${photographer}</strong></p>
    <div class="hero">
      <div class="watermark reveal r2">${watermark}</div>
      <div class="headline reveal r3"><span class="headline-text">${line1}<br>${line2}</span></div>
    </div>
    <p class="dek reveal r4">${dek}</p>
    <div class="logo reveal r5"><img src="${LOGO_PRETO_DATA_URI}" alt="Lorena"></div>
  </section>`
}

export const capaTemplate: TemplateDefinition = {
  id: 'capa',
  label: 'Capa',
  tags: ['homem', 'abertura'],
  css: CSS,
  fieldsSchema: [
    { key: 'writer', label: 'Redator', type: 'text', defaultValue: 'André Pontes', placeholder: 'Nome do redator' },
    {
      key: 'photographer',
      label: 'Fotógrafo',
      type: 'text',
      defaultValue: 'Airiela Leiria',
      placeholder: 'Nome do fotógrafo',
    },
    { key: 'watermark', label: 'Selo', type: 'text', defaultValue: 'ENTREVISTA' },
    { key: 'headlineLine1', label: 'Nome (linha 1)', type: 'text', placeholder: 'NOME DE' },
    { key: 'headlineLine2', label: 'Sobrenome (linha 2)', type: 'text', placeholder: 'EXEMPLO' },
    {
      key: 'dek',
      label: 'Resumo',
      type: 'textarea',
      help: 'Use **texto** para deixar um trecho em negrito.',
      placeholder: 'Subtítulo de exemplo com um **trecho em destaque**...',
    },
  ],
  render,
  previewContent: {
    writer: 'André Pontes',
    photographer: 'Airiela Leiria',
    watermark: 'ENTREVISTA',
    headlineLine1: 'TÍTULO DE',
    headlineLine2: 'EXEMPLO',
    dek: 'Texto de exemplo com um **trecho em destaque** para ilustrar o resumo da matéria.',
  },
}
